import { Dialog, Slide, Theme, WithStyles, createStyles, withStyles } from '@material-ui/core';
import { IStoreState, ThunkDispatch } from '../../modules';
import React, { Component } from 'react';

import ExchangesComponent from './ExchangesComponent';
import { TransitionProps } from '@material-ui/core/transitions/transition';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { setViewerVisibility } from '../../modules/tracelog';

const styles = (theme: Theme) => createStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'flex-start',
    backgroundColor: 'red',
    flex: 1,
  },
  titleBar: {
    flex: '0 0 auto',
  },
  flex: {
    flex: 1,
  },
})

type State = {
}

class SoapViewer extends Component<Props, State> {
  transition = React.forwardRef<unknown, TransitionProps>((props: any, ref: any) =>
    <Slide direction="up" {...props} ref={ref}/>
  )

  handleClose = () => {
    const { setViewerVisibility } = this.props
    setViewerVisibility(false)
  }

  render() {
    const { tracelog } = this.props

    return (
      <Dialog
        fullScreen
        open={tracelog.viewerOpen}
        onClose={this.handleClose}
        TransitionComponent={this.transition}
      >
        <ExchangesComponent tracelog={tracelog}/>
      </Dialog>
    )
  }
}

const mapStateToProps = ({ accounts, intl, tracelog }: IStoreState) => ({
  accounts,
  intl,
  tracelog
})

const mapDispatchToProps = (dispatch: ThunkDispatch) =>
  bindActionCreators(
    {
      setViewerVisibility
    }, dispatch
  )

interface Props extends WithStyles<typeof styles>, ReturnType<typeof mapStateToProps>, ReturnType<typeof mapDispatchToProps> {
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(SoapViewer));